<template>
  <el-container>
    <el-header>
      <home-header></home-header>
    </el-header>
    <el-container v-if="isShow">
      <home-side></home-side>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import HomeHeader from '@/common/components/head/HomeHeader'
import HomeSide from '@/common/components/side/HomeSide'

export default {
  name: "index",
  data() {
    return {
      width: '',
      isShow: true,
    }
  },
  components: {HomeHeader, HomeSide},
}
</script>

<style lang="scss" scoped>
.el-container {
  height: 100%;
}

.el-header {
  height: 50px !important;
  padding: 0;
}

.el-main {
  padding: 15px;
  background-color: #f3f4f6;
}
</style>
